/* Presentation + local photo previews. Shopify's native product form owns cart submission. */
(() => {
  if (!customElements.get('mcc-ring-customizer')) {
    customElements.define('mcc-ring-customizer', class extends HTMLElement {
      connectedCallback() {
        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', () => this.init(), { once: true });
        } else this.init();
      }
      disconnectedCallback() {
        this.abort?.abort();
        this.urls?.forEach(url => URL.revokeObjectURL(url));
        this.initialized = false;
      }
      init() {
        if (this.initialized || !this.isConnected) return;
        this.initialized = true;
        this.abort = new AbortController();
        const signal = this.abort.signal;
        const strings = JSON.parse(this.querySelector('[data-customizer-strings]').textContent);
        const picker = this.querySelector('[data-photo-picker]');
        const trigger = this.querySelector('[data-upload-trigger]');
        const inputs = [...this.querySelectorAll('[data-photo-input]')];
        const previews = this.querySelector('[data-preview-list]');
        const status = this.querySelector('[data-upload-status]');
        const error = this.querySelector('[data-upload-error]');
        const form = document.getElementById(this.dataset.productFormId);
        if (form) form.enctype = 'multipart/form-data';
        // The product has one size option. Keep the actual submitted variant in sync
        // even when Horizon's asynchronous section/module updates are unavailable.
        const section = this.closest('.shopify-section');
        const getSizeSelect = () => section?.querySelector('variant-picker[data-product-handle="custom-pet-hug-ring"] select');
        const syncVariant = () => {
          const select = getSizeSelect();
          const variantId = select?.selectedOptions[0]?.dataset.variantId;
          const currentForm = document.getElementById(this.dataset.productFormId);
          const input = currentForm?.querySelector('input[name="id"]');
          if (!input || !/^\d+$/.test(variantId || '')) return false;
          input.value = variantId;
          return true;
        };
        window.addEventListener('change', event => {
          if (event.target === getSizeSelect()) syncVariant();
        }, {capture: true, signal});
        syncVariant();
        this.urls = [];
        const entries = () => inputs.filter(input => input.files?.length).map(input => ({ input, file: input.files[0] }));
        const showError = message => {
          error.textContent = message;
          error.hidden = !message;
          if (message) trigger.setAttribute('aria-invalid', 'true');
          else trigger.removeAttribute('aria-invalid');
        };
        const render = () => {
          this.urls.forEach(url => URL.revokeObjectURL(url));
          this.urls = [];
          previews.replaceChildren();
          const selected = entries();
          // Native validation protects the form before this deferred script is ready.
          inputs[0].required = selected.length === 0;
          previews.hidden = !selected.length;
          status.textContent = selected.length + ' / 5 ' + strings.added;
          selected.forEach(({input,file}) => {
            const figure = document.createElement('figure');
            figure.className = 'mcc-pet-customizer__preview-item';
            const image = document.createElement('img');
            const url = URL.createObjectURL(file);
            this.urls.push(url);
            image.src = url;
            image.alt = strings.preview + ' ' + file.name;
            image.className = 'mcc-pet-customizer__preview-image';
            const remove = document.createElement('button');
            remove.type = 'button';
            remove.className = 'mcc-pet-customizer__remove';
            remove.textContent = strings.remove;
            remove.setAttribute('aria-label', strings.remove + ' ' + file.name);
            remove.addEventListener('click', () => {
              input.value = '';
              showError('');
              render();
              trigger.focus();
            });
            figure.append(image, remove);
            previews.append(figure);
          });
        };
        trigger.addEventListener('click', () => {
          if (entries().length >= 5) { showError(strings.limit); return; }
          picker.click();
        }, {signal});
        picker.addEventListener('change', () => {
          const files = [...picker.files];
          if (!files.length) return;
          let message = '';
          for (const file of files) {
            if (!['image/jpeg','image/png','image/webp'].includes(file.type)) { message = strings.type; continue; }
            if (file.size > 10 * 1024 * 1024) { message = strings.size; continue; }
            const slot = inputs.find(input => !input.files?.length);
            if (!slot) { message = strings.limit; break; }
            const transfer = new DataTransfer();
            transfer.items.add(file);
            slot.files = transfer.files;
          }
          picker.value = '';
          render();
          showError(message);
        }, {signal});
        // Window capture runs before Horizon's document-level event delegation.
        const validateSubmission = event => {
          if (!syncVariant()) {
            event.preventDefault();
            event.stopImmediatePropagation();
            showError('Please choose your ring size again before adding to cart.');
            getSizeSelect()?.focus();
            return;
          }
          const invalid = [...this.querySelectorAll('input[type=text],select,textarea')].find(field => !field.checkValidity());
          if (invalid || !entries().length) {
            event.preventDefault();
            event.stopImmediatePropagation();
            if (invalid) { invalid.focus(); invalid.reportValidity(); }
            else { showError(strings.empty); trigger.focus(); }
          } else showError('');
        };
        window.addEventListener('submit', event => {
          // An input named "id" shadows form.id.
          if (event.target.getAttribute('id') === this.dataset.productFormId) validateSubmission(event);
        }, {capture:true,signal});
        window.addEventListener('click', event => {
          const button = event.target instanceof Element ? event.target.closest('button[type="submit"]') : null;
          if (button?.form?.getAttribute('id') === this.dataset.productFormId) validateSubmission(event);
        }, {capture:true,signal});
        trigger.disabled = false;
        render();
      }
    });
  }
})();
